import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { SlideDown } from 'react-slidedown'
import analytics from '../../helpers/analytics'
import config from 'config'
import {
  Link,
  LinkIcon
} from '../'
import Styles from './AmazonStaffLetters.css'

@CSSModules(Styles,{allowMultiple:true})
export default class AmazonStaffLetters extends Component {
  constructor(props) {
    super(props)

    const letterTo = 'winters@amazon.com'
    const letterSubject = 'Amazon 401(k) sustainability'
    const letterText = `
Dear Mr. Winter,

I am an employee of Amazon.com, and I participate in our company retirement plan. I recently found out that the Amazon.com 401(k) has significant investments in fossil fuels, deforestation, arms manufacturers, and companies that score poorly on gender equality. I care about these issues and do not want my retirement savings to support companies that are destroying the environment and fueling social inequality.

The data on the Amazon.com 401(k) can be found here:
https://investyourvalues.org/retirement-plans/amazon-com

I am also concerned about the financial risks associated with investing my retirement savings in unsustainable industries. Sustainable investing is not just an ethical issue - it is a key factor impacting financial well-being. Department of Labor guidelines state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty. Now that I know what I am invested in through our plan, I no longer want to jeopardize my financial security by investing in these risky industries.

Critically, the default plan option, the Vanguard Target Retirement Fund series, is not invested sustainably. Over 50% of assets invested in the Amazon employee retirement plan are invested in these default option target date funds. Because these funds are not invested sustainably, hundreds of millions of dollars in employee savings are being allocated to fossil fuel companies, deforestation-risk commodity producer/traders, and other sustainability risk sectors.

I am proud of the steps we have taken as a company to protect the environment, but we need to have more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon. Please let me know how we can ensure that our company retirement plan is no longer complicit in the destruction of our environment.

I would like to have investment options that support an economy that is based on justice and sustainability. Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you soon.

Best,
    `

    const emailHref = `mailto:${letterTo}?subject=${encodeURIComponent(letterSubject)}&body=${encodeURIComponent(letterText)}`

    this.state = {
      showAdminLetter: false,
      emailHref
    }
  }

  render() {
    const { showAdminLetter, emailHref } = this.state
    //
    return (
      <div styleName='letter-box'>
        <div styleName='letter-box-flex'>
          <div styleName='letter-box-label'>
            <h2>
              Send a message to your 401(k) plan administrator
            </h2>
            <p>
              Send a message to your 401(k) plan administrator asking them for a sustainable 401(k).
            </p>
            <p>
              <button
                styleName='show-letter-button'
                onClick={
                  () => {
                    this.setState(
                      { showAdminLetter: !showAdminLetter }
                    )
                  }
                }
              >
                Letter to plan admin<LinkIcon
                  faclass={
                    showAdminLetter ?
                      'fa-angle-double-up' :
                      'fa-angle-double-down'
                  }
                />
              </button>
            </p>
          </div>
          <div styleName='take-action-icons'>
            <div>
              <Link
                to={emailHref}
                title='Send a message to your 401(k) plan administrator'
                log={analytics.eventStaffSupport('Amazon','admin_message')}
                targetBlank
              >
                <div>
                  <p>
                    Email
                  </p>
                  <div>
                    <LinkIcon nospace faclass='fa-envelope'/>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <SlideDown>
          {
            showAdminLetter ?
              (
                <div styleName='company-letter-slidedown'>
                  <p>
                    Your retirement plan administrator has a legal
                    responsibility to act solely in your interest as a plan
                    participant. Most 401(k) investors are primarily
                    concerned with generating positive returns, but <Link
                      to={config.routes.eduCenterFinRisks}
                      title='Financial risks of unsustainable investments'
                      xstrong
                    >unsustainable investments could be increasing your
                    financial risk,</Link> while also destroying the environment
                    and fueling social inequality. If these are issues that
                    you care about, then your plan administrator has a
                    responsibility to make sure you have the option to
                    invest sustainably. Below is a sample letter you can
                    send to your 401(k) Plan Administrator at Amazon.com,
                    Steve Winter (winters@amazon.com).
                  </p>
                  <blockquote styleName='company-letter-blockquote'>
                    <p>Dear Mr. Winter,</p>

                    <p>I am an employee of Amazon.com, and I participate in our company retirement plan. I recently found out that the Amazon.com 401(k) has significant investments in fossil fuels, deforestation, arms manufacturers, and companies that score poorly on gender equality. I care about these issues and do not want my retirement savings to support companies that are destroying the environment and fueling social inequality.</p>

                    <p>The data on the Amazon.com 401(k) can be found here:<br/>
                    <Link
                      to={config.routes.plans + '/amazon-com'}
                      title='Amazon.com retirement plan sustainability scorecard'
                      xstrong
                    >https://investyourvalues.org/retirement-plans/amazon-com</Link></p>

                    <p>I am also concerned about the financial risks associated with investing my retirement savings in unsustainable industries. Sustainable investing is not just an ethical issue - it is a key factor impacting financial well-being.  Department of Labor guidelines state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty. Now that I know what I am invested in through our plan, I no longer want to jeopardize my financial security by investing in these risky industries. </p>

                    <p>Critically, the default plan option, the Vanguard Target Retirement Fund series, is not invested sustainably. Over 50% of assets invested in the Amazon employee retirement plan are invested in these default option target date funds. Because these funds are not invested sustainably, hundreds of millions of dollars in employee savings are being allocated to fossil fuel companies, deforestation-risk commodity producer/traders, and other sustainability risk sectors.</p>

                    <p>I am proud of the steps we have taken as a company to protect the environment, but we need to have more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon. Please let me know how we can ensure that our company retirement plan is no longer complicit in the destruction of our environment. </p>

                    <p>I would like to have investment options that support an economy that is based on justice and sustainability. Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you soon.</p>

                    <p>Best,<br/>
                    <b>[Your Name]<br/>
                    [Your contact information: company department, email, phone, etc.]</b></p>
                  </blockquote>
                </div>
              ) :
              null
          }
        </SlideDown>

      </div>
    )
  }
}
